import {AsyncState} from "../asyncState";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {Order} from "./types";
import {cancelOrder, fetchOrders} from "./thunks";

/**
 * fetchOrders のクエリに使用する.
 * @field fetchedPages フェッチしたページ番号を保存する. 検索クエリが変更されたとき初期化される.
 * @field fromIndex from(Timestamp)以後に作成されたorderのindex
 * @field toIndex to(Timestamp)以前に作成されたorderのindex
 */
export type QueryKey = {
  fetchedPages: number[],
  fromIndex: number | undefined,
  toIndex: number | undefined,
}

/**
 * orderSlice の型
 */
export type OrderState = AsyncState<Order[]> & QueryKey

/**
 * uses/{userId}/orders コレクションのデータ
 */
const orderSlice = createSlice({
  name: 'orders',
  initialState: {
    data: [],
    status: "idle",
    error: "",
    fetchedPages: [],
    fromIndex: undefined,
    toIndex: undefined,
  } as OrderState,
  reducers: {
    addFetchedPage(state, action: PayloadAction<number>) {
      state.fetchedPages.push(action.payload);
    },
    setFromIndex(state, action: PayloadAction<number>) {
      state.fromIndex = action.payload;
    },
    setToIndex(state, action: PayloadAction<number>) {
      state.toIndex = action.payload;
    },
    initQueryKey(state) {
      state.fetchedPages = [];
      state.fromIndex = undefined;
      state.toIndex = undefined;
    },
    clearFetchedPages(state) {
      state.fetchedPages = [];
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchOrders.fulfilled, (state, action) => {
        const payload = action.payload;
        const payloadIndexes = payload.map(p => p.index);
        state.data = [...payload, ...state.data.filter(o => !payloadIndexes.includes(o.index))]; // selector でソートする
        state.status = "succeeded";
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      })

    builder.addCase(cancelOrder.fulfilled, (state, action) => {
      const orderIndex = state.data.findIndex(o => o.id === action.meta.arg.orderId);

      if (orderIndex !== -1) {
        state.data[orderIndex] = {...state.data[orderIndex], ...action.payload};
      }
    })
  }
});

export const {addFetchedPage, setFromIndex, setToIndex, initQueryKey, clearFetchedPages} = orderSlice.actions;
const orderReducer = orderSlice.reducer;
export default orderReducer;